const PLANS_ACTION = {
  ADD_WORKOUTS: 'PLANS_ADD_WORKOUTS',
  ADD_SMART: 'PLANS_ADD_SMART',
  ADD_WORKOUT_LOG: 'ADD_WORKOUT_LOG',
  CREATE: 'PLANS_CREATE',
  CREATE_SMART: 'PLANS_CREATE_SMART',
  CLONE: 'PLANS_CLONE',
  CLONE_RECOMMENDED: 'PLANS_CLONE_RECOMMENDED',
  COPY: 'PLANS_COPY',
  DELETE: 'PLANS_DELETE',
  DELETE_RECOMMENDED_AT: 'PLANS_DELETE_RECOMMENDED_AT',
  DELETE_FROM_NON_ENDED_DOMAIN_LIST: 'PLANS_DELETE_FROM_NON_ENDED_DOMAIN_LIST',
  DELETE_LOCAL_IS_DOWNLOADED: 'PLANS_DELETE_LOCAL_IS_DOWNLOADED',
  DELETE_PARENT_ID: 'PLANS_DELETE_PARENT_ID',
  UPDATE_LOCAL_START_DATE: 'PLANS_UPDATE_LOCAL_START_DATE',
  LOAD: 'PLANS_LOAD',
  LOAD_CHALLENGES: 'PLANS_LOAD_CHALLENGES',
  LOAD_STARTED: 'PLANS_LOAD_STARTED',
  LOAD_BY_ID: 'PLANS_LOAD_BY_ID',
  LOAD_RECOMMENDED: 'PLANS_LOAD_RECOMMENDED',
  LOG: 'PLANS_LOG',
  RESET_STARTED: 'PLANS_RESET_STARTED',
  RESET_SUGGESTED: 'PLANS_ACTION_RESET_SUGGESTED',
  RESET_STATE: 'PLANS_RESET_STATE',
  RESET_SMART: 'PLANS_RESET_SMART',
  SAVE: 'PLANS_SAVE',
  UPDATE: 'PLANS_UPDATE',
  UPDATE_LOCAL_IS_DOWNLOADED: 'PLANS_UPDATE_LOCAL_IS_DOWNLOADED',
  UPDATE_WORKOUTS_PLAN_ID: 'PLANS_UPDATE_WORKOUTS_PLAN_ID',
  UPDATE_WORKOUTS: 'PLANS_UPDATE_WORKOUTS',
  UPDATE_WORKOUTS_PLANNED_AT: 'PLANS_UPDATE_WORKOUTS_PLANNED_AT',
  UPDATE_DATA: 'PLANS_UPDATE_DATA',
  UPDATE_SUGGESTED: 'PLANS_ACTION_UPDATE_SUGGESTED',
  UPDATE_SMART: 'PLANS_UPDATE_SMART',
  UPDATE_STARTED_AT: 'PLANS_UPDATE_STARTED_AT',
  UPDATE_LOGGED_AT: 'PLANS_UPDATE_LOGGED_AT',
  UPDATE_CURRENT: 'PLANS_UPDATE_CURRENT',
  UPDATE_SMART_SUCCESS_STATUS: 'PLANS_UPDATE_SMART_SUCCESS_STATUS',
  UPDATE_RECOMMENDED_AT: 'PLANS_UPDATE_RECOMMENDED_AT',
  UPDATE_PROFILE_ID: 'PLANS_UPDATE_PROFILE_ID',
  UPDATE_NAME: 'PLANS_UPDATE_NAME',
  UPDATE_NOTE: 'PLANS_UPDATE_NOTE',
  UPDATE_STARTED: 'PLANS_UPDATE_STARTED',
  UPDATE_LOCAL_HAS_ASSOCIATION_CHANGE: 'PLANS_UPDATE_LOCAL_HAS_ASSOCIATION_CHANGE'
}

export default PLANS_ACTION
